import { Injectable } from '@angular/core';
import { config } from '@app/config/app';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    turnstile?: any;
  }
}

@Injectable({
  providedIn: 'root',
})
export class RecaptchaService {
  private siteKey = config.captchaKey;

  constructor() {
    this.loadTurnstileScript();
  }

  private loadTurnstileScript() {
    if (!document.getElementById('turnstile-script')) {
      console.log('[Turnstile] Loading Turnstile script...');
      const script = document.createElement('script');
      script.id = 'turnstile-script';
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.onload = () => console.log('[Turnstile] Script loaded.');
      document.head.appendChild(script);
    } else {
      console.log('[Turnstile] Script already loaded.');
    }
  }

  execute(action: string = 'submit'): Promise<string | boolean> {
    console.log(`[Turnstile] Executing Turnstile for action: ${action}`);
    return new Promise((resolve) => {
      const checkAndRender = () => {
        if (typeof window.turnstile === 'undefined') {
          console.log('[Turnstile] Waiting for Turnstile script to load...');
          setTimeout(checkAndRender, 100);
          return;
        }

        // Remove any previous widget
        const existing = document.getElementById('turnstile-widget');
        if (existing) {
          console.log('[Turnstile] Removing previous widget.');
          existing.remove();
        }

        // Create a container for the widget
        const container = document.createElement('div');
        container.id = 'turnstile-widget';
        container.style.display = 'none'; // Invisible
        document.body.appendChild(container);

        console.log('[Turnstile] Rendering invisible widget...');
        // Render the invisible widget
        const widgetId = window.turnstile.render(container, {
          'sitekey': this.siteKey,
          'size': 'invisible',
          'callback': (token: string) => {
            console.log('[Turnstile] Token received:', token);
            resolve(token);
            setTimeout(() => {
              console.log('[Turnstile] Removing widget after success.');
              container.remove();
            }, 1000);
          },
          'error-callback': () => {
            console.error('[Turnstile] Error callback triggered.');
            resolve(false);
            setTimeout(() => {
              console.log('[Turnstile] Removing widget after error.');
              container.remove();
            }, 1000);
          },
        });

        console.log('[Turnstile] Executing invisible challenge...');
        // Execute the challenge
        window.turnstile.execute(widgetId);
      };

      if (typeof window.turnstile !== 'undefined') {
        checkAndRender();
      } else {
        setTimeout(checkAndRender, 500);
      }
    });
  }
}
